import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getTranslation } from '../utils/translations';
import { SvgIcon } from './SvgIcon';
import { navSelector } from 'store/modules/competition-nav/selectors';
import { filtersSelector as eventsFiltersSelector } from 'store/modules/events-listing/selectors';

export const FilterButton = ({
    onChange,
    areFilterOptionsVisible,
    showFilterLabel,
    showActiveCircle = false,
    isFilterSelectedCustom = () => false
}) => {
    const nav = useSelector(navSelector);
    const homeAwayFilter = nav.homeAway;
    const eventsFilters = useSelector(eventsFiltersSelector);

    const filterSelected =
        homeAwayFilter !== 'all' ||
        eventsFilters?.eventTypes.length > 0 ||
        eventsFilters?.eventLocations.length > 0 ||
        eventsFilters?.teams.length > 0 ||
        isFilterSelectedCustom();

    return (
        <button
            className={classNames(
                'filter-button',
                {
                    'filter-button--active': areFilterOptionsVisible
                },
                {
                    'filter-button--selected': filterSelected
                },
                {
                    'filter-button--selected-no-bar':
                        !areFilterOptionsVisible && filterSelected
                }
            )}
            onClick={onChange}
        >
            <SvgIcon
                icon={
                    'filter-circle' +
                    (showActiveCircle && areFilterOptionsVisible
                        ? '-active'
                        : '')
                }
                className="filter-button__icon"
                folder="elements"
                subfolder="stats"
            />
            <SvgIcon
                icon={
                    'filter-circle' +
                    (showActiveCircle &&
                    filterSelected &&
                    areFilterOptionsVisible
                        ? '-active'
                        : '-fill')
                }
                className="filter-button__icon-active"
                folder="elements"
                subfolder="stats"
            />
            {showFilterLabel ??
                getTranslation('label.statsLeaders.filters.toggleButtonText')}
        </button>
    );
};

FilterButton.propTypes = {
    onChange: PropTypes.func.isRequired,
    areFilterOptionsVisible: PropTypes.bool,
    showActiveCircle: PropTypes.bool,
    showFilterLabel: PropTypes.bool,
    isFilterSelectedCustom: PropTypes.func
};
